interface PositionProps {
  title: string;
  company: string;
  timeFrame: string;
  responsibilities?: string[];
}

function Position({
  title,
  company,
  timeFrame,
  responsibilities,
}: PositionProps) {
  return (
    <section>
      <span className="w-full flex flex-col md:flex-row justify-end md:justify-between items-center sm:items-start">
        <h3 className="font-bold text-lg md:text-3xl lg:text-3xl text-nowrap self-center">
          {title}
        </h3>
        <span className="w-full md:w-fit flex flex-row justify-between md:justify-center items-end md:flex-col md:items-end-safe text-left md:text-right">
          <h4 className="text-sm lg:text-xl italic">{company}</h4>
          <p className="text-sm lg:text-base p-0 text-right">{timeFrame}</p>
        </span>
      </span>
      <hr className="w-full mx-auto opacity-30 my-2" />
      {responsibilities && <ul className="text-sm md:text-base lg:text-lg list-disc text-left px-4 md:px-8">
        {responsibilities.map((r, i) => (
          <li key={i}>{r}</li>
        ))}
      </ul>}
    </section>
  );
}

export default Position;
